import { render } from "./AreaSelectedAreas.vue?vue&type=template&id=31c720bc&scoped=true"
import script from "./AreaSelectedAreas.vue?vue&type=script&lang=js"
export * from "./AreaSelectedAreas.vue?vue&type=script&lang=js"

import "./AreaSelectedAreas.vue?vue&type=style&index=0&id=31c720bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c720bc"]])

export default __exports__